import { render, staticRenderFns } from "./Remplacements.vue?vue&type=template&id=bc5c128a&"
import script from "./Remplacements.vue?vue&type=script&lang=js&"
export * from "./Remplacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports